export default __webpack_public_path__ + "static/geoff-roslyn-cafe-d9d16dc12f90c3a85a3c3d8e74b38679.jpg";